!function(e,n){"object"==typeof exports&&"object"==typeof module?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.storeblocks=n():e.storeblocks=n()}(self,(()=>(()=>{"use strict";var e={99:(e,n,r)=>{r.d(n,{default:()=>d});var o=r(15),t=r.n(o),i=r(770),a=r.n(i),l=r(597);const c=a().div`
  display: inline-flex;
  flex-direction: column;

  background: var(--color-warning-background);
  outline: 3px solid var(--color-warning-accent);

  padding: 16px 32px 8px 16px;

  ${({variant:e})=>"warning"===e?i.css`
        background: var(--color-warning-background);
      `:i.css`
      outline: 3px solid var(--color-error-accent);
      background: var(--color-error-background);
    `}
`,s=a().div`
  display: inline-flex;

  font-weight: 600;
  line-height: 24px;

  margin-bottom: 24px;

  & > i {
    margin-right: 24px;
  }
`,d=function({title:e,variant:n="warning",visible:r=!1,children:i}){const a=(0,o.useMemo)((()=>"warning"===n?t().createElement(l.SystemIcon,{size:24,name:"warning-filled",color:"warning-accent"}):t().createElement(l.SystemIcon,{size:24,name:"error-filled",color:"error-accent"})),[n]);return r?t().createElement(c,{variant:n},t().createElement(s,null,a,e),i):i}},610:(e,n,r)=>{r.d(n,{default:()=>s});var o=r(15),t=r.n(o),i=r(770),a=r.n(i),l=r(597);const c=a().div`
  display: flex;
  align-items: center;

  flex-shrink: 0;

  width: 16px;
  height: 16px;

  margin: 16px 16px 16px 0;

  background: var(--color-background);

  /* border-radius: 2px; */
  /* border: 2px solid var(--color-on-background); */
  box-sizing: border-box;

  & > i {
    color: var(--color-selection);
  }
  /*
  ${({checked:e,indeterminate:n})=>(e||n)&&i.css`
      border-color: var(--color-selection);
      background: var(--color-selection);
    `} */

  ${e=>function(e,n){var r={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&n.indexOf(o)<0&&(r[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var t=0;for(o=Object.getOwnPropertySymbols(e);t<o.length;t++)n.indexOf(o[t])<0&&Object.prototype.propertyIsEnumerable.call(e,o[t])&&(r[o[t]]=e[o[t]])}return r}(e,[])["aria-disabled"]&&i.css`
      & > i {
        color: var(--color-disabled);
      }
    `}
`,s=function({checked:e,indeterminate:n,disabled:r}){return t().createElement(c,{checked:e,indeterminate:n,"aria-disabled":r},!e&&t().createElement(l.SystemIcon,{name:"selection-controls-unchecked",size:16}),e&&t().createElement(l.SystemIcon,{name:"selection-controls-checked",size:16}),n&&t().createElement(l.SystemIcon,{name:"selection-controls-indeterminate",size:16}))}},422:(e,n,r)=>{r.d(n,{default:()=>p});var o=r(15),t=r.n(o),i=r(341),a=r.n(i);const l=require("@storeblocks/popover");var c=r.n(l),s=r(568),d=r(610);const p=function({id:e,name:n,label:r,value:i,onChange:l,checked:p=!1,indeterminate:u=!1,disabled:b=!1,hint:f,info:g,inputProps:x,labelProps:m,hintProps:v,popoverProps:h}){const y=`labeledby-id_${e}`,w=(0,o.useMemo)((()=>u?"mixed":p?"true":"false"),[p,u]);return t().createElement(s.SingleBase,null,t().createElement(s.Box,null,t().createElement(t().Fragment,null,t().createElement("input",Object.assign({type:"checkbox",id:e,name:n,value:i,onChange:function(e){b||l(e)},checked:p,"aria-checked":w,"aria-disabled":b,"aria-labelledby":y},x)),t().createElement(s.Label,Object.assign({id:y,htmlFor:e,"aria-disabled":b},m),t().createElement(d.default,{checked:p,indeterminate:u,disabled:b}),r.length>0&&t().createElement(s.LabelText,null,r))),g&&t().createElement(c(),Object.assign({},h),g)),f&&t().createElement(a(),Object.assign({},v),f))}},568:(e,n,r)=>{r.d(n,{Box:()=>c,CheckboxBase:()=>s,CheckboxGroupLabel:()=>d,Label:()=>a,LabelText:()=>l,SingleBase:()=>i});var o=r(770),t=r.n(o);const i=t().div`
  display: flex;
  flex-direction: column;

  & .popover > button > i {
    color: var(--color-on-background);
  }

  & > .hint {
    margin: 8px 40px;

    & > p,
    & > p > a {
      font-size: 14px;
    }
  }

  & input {
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    width: 1px;
    opacity: 0;
    overflow: hidden;
  }

  & input:focus + label {
    outline: var(--outline);
  }

  & input:focus:not(:focus-visible) + label {
    outline: 0;
  }

  & input:focus-visible + label {
    outline: var(--outline);
  }

  /* focus styles for read-more button */
  & > button:focus {
    outline: var(--outline);
    outline-offset: 4px;
  }
  & > button:focus:not(:focus-visible) {
    outline: 0;
  }
  & > button:focus-visible {
    outline: var(--outline);
    outline-offset: 4px;
  }
`,a=t().label`
  align-items: center;
  display: flex;
  box-sizing: border-box;

  font-family: 'Open Sans', sans-serif;
  line-height: 24px;

  user-select: none;
  cursor: pointer;

  ${e=>e["aria-disabled"]&&o.css`
      color: var(--color-disabled);
      cursor: not-allowed;
    `}
`,l=t().div`
  margin-left: 4px;
  line-height: 24px;
`,c=t().div`
  display: flex;
`,s=t().div`
  /*
   Make the element only as wide as the content.
  */
  display: inline-flex;
  display: inline-flex;
  flex-direction: column;

  line-height: 16px;
  font-size: 16px;
  font-family: 'Open Sans';
  color: var(--color-on-background);

  padding: 0;
  margin: 0;
  outline-offset: -3px;
  border: none;

  & > .hint {
    font-size: 14px;

    & > p {
      font-size: 14px;
    }
    margin: -8px 0 16px 0;
  }

  ${e=>e["aria-disabled"]&&o.css`
      color: var(--color-disabled);
    `}
`,d=t().p`
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 16px;
  word-wrap: break-word;
  float: left;
`;t().div`
  display: flex;
  align-items: center;

  font-weight: 600;
  line-height: 24px;

  padding: 16px 24px 16px 16px;

  & > i {
    font-size: 24px;

    margin-right: 24px;

    ${({warning:e,error:n})=>e?o.css`
          color: var(--color-warning-accent);
        `:n?o.css`
          color: var(--color-error-accent);
        `:""}
  }
`},341:e=>{e.exports=require("@storeblocks/hint")},597:e=>{e.exports=require("@storeblocks/icon")},15:e=>{e.exports=require("react")},770:e=>{e.exports=require("styled-components")}},n={};function r(o){var t=n[o];if(void 0!==t)return t.exports;var i=n[o]={exports:{}};return e[o](i,i.exports,r),i.exports}r.n=e=>{var n=e&&e.__esModule?()=>e.default:()=>e;return r.d(n,{a:n}),n},r.d=(e,n)=>{for(var o in n)r.o(n,o)&&!r.o(e,o)&&Object.defineProperty(e,o,{enumerable:!0,get:n[o]})},r.o=(e,n)=>Object.prototype.hasOwnProperty.call(e,n),r.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var o={};return(()=>{r.r(o),r.d(o,{Checkbox:()=>d,SingleCheckbox:()=>l.default,default:()=>p});var e=r(15),n=r.n(e),t=r(341),i=r.n(t),a=r(568),l=r(422),c=r(99),s=function(e,n){var r={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&n.indexOf(o)<0&&(r[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var t=0;for(o=Object.getOwnPropertySymbols(e);t<o.length;t++)n.indexOf(o[t])<0&&Object.prototype.propertyIsEnumerable.call(e,o[t])&&(r[o[t]]=e[o[t]])}return r};function d(e){var{id:r,name:o,label:t,hint:d,disabled:p=!1,error:u,warning:b,onChange:f,value:g,options:x,labelProps:m,hintProps:v}=e,h=s(e,["id","name","label","hint","disabled","error","warning","onChange","value","options","labelProps","hintProps"]);if(u&&b)throw new Error("Cannot assign both error and warning properties, must choose one or the other.");if("boolean"==typeof g&&1!==x.length)throw new Error("Setting a boolean as value is only accepted when you have set single option only");const y=`${r}-radio-label`,w=`${r}-radio-error`,k=`${r}-radio-warning`,O=`${y} ${k} ${w}`,E=e=>{var n,r;if(!p&&"true"!==(null===(r=null===(n=e.target.attributes)||void 0===n?void 0:n["aria-disabled"])||void 0===r?void 0:r.value))if("boolean"!=typeof g){const n=g.includes(e.target.value)?g.filter((n=>n!==e.target.value)):[...g,e.target.value],r=x.filter((e=>n.includes(e.value)));f(e,n,r)}else f(e)};return n().createElement(c.default,{id:w||k,visible:!(!u&&!b),title:u||b,variant:u?"error":"warning"},n().createElement(a.CheckboxBase,Object.assign({"aria-labelledby":O,"aria-disabled":p,error:u,warning:b},h),function(){const e=!(!b&&!u);return t&&n().createElement(a.CheckboxGroupLabel,Object.assign({id:y,attention:e},m),t)}(),d&&n().createElement(i(),Object.assign({},v),d),x.map((e=>n().createElement(l.default,Object.assign({key:e.id,name:o,id:e.id,label:e.label,hint:e.hint,value:e.value,checked:"boolean"==typeof g?g:g.includes(e.value),onChange:E,disabled:p||e.disabled,"aria-required":e.required},e))))))}const p=d})(),o})()));
//# sourceMappingURL=index.js.map